// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3OY_Q","menu":"Menu_menu__2xbQm","back":"Menu_back__3UrCW","forward":"Menu_forward__35C8X","heading":"Menu_heading__1N1a1"};